import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

function BackButton({ to, variant, noMargin, style }) {
  const navigate = useNavigate();
  return (
    <div className={`${noMargin ? '' : 'mb-3'}`}>
      {to ? (
        <StyledLinkButton to={to}>
          {' '}
          <FormattedMessage id="button.back" />
        </StyledLinkButton>
      ) : (
        <Button variant={variant} className={style} onClick={() => navigate(-1)}>
          <FormattedMessage id="button.back" />
        </Button>
      )}
    </div>
  );
}

export default BackButton;

const StyledLinkButton = styled(Link)`
  padding: 0.5rem 1em;
  background: #617762;
  color: white;
  border-radius: 5px;
  :hover {
    color: white;
  }
`;
